import { PathOptions } from "leaflet";

export const neoenergia_pe_uncrat = (feature: any): PathOptions => {
  // Unidades Consumidoras AT - Purple-red circles
  return {
    color: "#990066", // Purple-red border
    weight: 1,
    opacity: 1,
    fillColor: "#CC3399", // Light purple-red fill
    fillOpacity: 0.7,
  };
};
